:host {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
